import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';
import { AssetsDataState } from '@/zustand/interfaces/assets-data';

export const useAssetsData = create<
  AssetsDataState,
  [['zustand/persist', unknown]]
>(
  persist(
    (set) => ({
      assetsData: null,
      setAssetsData: (assetsData) =>
        set({
          assetsData
        }),
      removeAssetsData: () =>
        set({
          assetsData: null
        })
    }),
    {
      name: 'assetsData',
      storage: createJSONStorage(() => localStorage)
    }
  )
);
